<template>
	<div
		class="pseudo-input"
	>
		<input
			type="search"
			class="input-bare w-full flex-1"
			placeholder="Grade"
			v-if="!grades.length"
			@click="openGradesModal"
		/>
		<span
			class="badge badge-secondary badge-sm mr-2 mb-2"
			v-for="(grade, index) in grades"
			v-bind:key="index"
		>
			{{ grade.id }}
			<a @click="removeGrade(grade)"><b-icon icon="x"></b-icon></a>
		</span>
		<span
			class="badge badge-primary badge-sm mr-2 mb-2"
			v-if="grades.length"
			@click="openGradesModal"
		>
			<b-icon icon="plus"></b-icon> {{ $t("add") }}
		</span>
	</div>
</template>

<script>
export default {
	props: {
		grades: Array
	},
	data: function() {
		return {
			gradeconfig: []
		}
	} ,
	mounted() {
		this.getGradeConfig();
	},
	methods: {
		getGradeConfig() {
			this.gradeconfig = [];
			var assessmentfields = this.$config.getValue("assessmentfields");
			for(var sectionid in assessmentfields){
				assessmentfields[sectionid].forEach(grade => {
					//For the time being, only grades are supported
					//if(grade.type == 'grade' || grade.type == 'oknotok'){
					if(grade.type == 'grade'){
						var newgrade = JSON.parse(JSON.stringify(grade));
						newgrade.proceduregrade = false;
						this.gradeconfig.push(newgrade);
					}
				});
			};
			var procedureassessmentfields = this.$config.getValue("proceduremarking");
			if(procedureassessmentfields && 'fields' in procedureassessmentfields){
				procedureassessmentfields.fields.forEach(grade => {
					//For the time being, only grades are supported
					//if(grade.type == 'grade' || grade.type == 'oknotok'){
					if(grade.type == 'grade'){
						var newgrade = JSON.parse(JSON.stringify(grade));
						newgrade.proceduregrade = true;
						this.gradeconfig.push(newgrade);
					}
				});
			};
		},
		openGradesModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Clinics',
				selectCallback: function(selection) {
					const isSelected = self.grades.find((grade, i) => {
						if (grade.id === selection.id) {
							self.$delete(self.grades, i);
							return true;
						}
					});
					if (!isSelected) {
						self.grades.push({
							"id": selection.id ,
							"caption": selection.caption ,
							"proceduregrade": ((('proceduregrade' in selection) && selection.proceduregrade)?true:false) ,
							"marks": []
						});
					}
				},
				selected: this.grades,
				data: this.gradeconfig,
				captionKey: "caption"
			});
		},

		removeGrade(selection) {
			const self = this;
			self.grades.find((grade, i) => {
				if (grade.id === selection.id) {
					self.$delete(self.grades, i);
					return true;
				}
			});
			return false;
		}
	},
	computed: {
	},
};
</script>
